export default __webpack_public_path__ + "e284e22f5d363c820923d7217f7d0630.svg";